<template>
    <div class="payment-error">
        <div class="payment-error__header">
          <div class="payment-error__icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
            </svg>
          </div>
            <h2 class="payment-error__title">{{ $t('payment_error.title') }}</h2>
        </div>
        
        <div class="payment-error__content">
            <div class="payment-error__message">
                <p class="payment-error__text">{{ $t('payment_error.payment_taken') }}</p>
                
                <p class="payment-error__datetime">
                  📅 {{ $t('payment_error.event_datetime') }}:
                  <br>
                  <b>{{ formattedTimestamp  }}</b>
                </p>
                
                <p class="payment-error__instructions">
                    {{ $t('payment_error.contact_staff') }}
                </p>
                
                <p class="payment-error__apology">
                    {{ $t('payment_error.apology') }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "VPaymentError",
    props: {
        timestamp: {
            type: String,
            default: () => new Date().toLocaleString('pl-PL', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            })
        }
    },
    computed: {
        formattedTimestamp() {
            return this.timestamp || new Date().toLocaleString('pl-PL', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        }
    }
}
</script>

<style lang="scss" scoped>
@import "/src/scss/assets/variables";

.payment-error {
    padding: 24px;
    text-align: center;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: $color_white_titan;
    
    &__header {
        margin-bottom: 32px;
    }
    
    &__title {
        font-size: 24px;
        font-weight: 700;
        color: #d32f2f;
        margin: 10px 0 16px 0;
        line-height: 1.2;
    }
    
    &__icon {
        width: 60px;
        height: 60px;
        margin: 0 auto;
        background-color: #d32f2f;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        
        svg {
            width: 40px;
            height: 40px;
        }
    }
    
    &__content {
        max-width: 500px;
        margin: 0 auto;
    }
    
    &__message {
        background-color: $color_white;
        border-radius: 12px;
        padding: 24px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        text-align: left;
        font-size: 16px;
    }
    
    &__text {
        //font-size: 16px;
        //font-weight: 600;
        //color: #d32f2f;
        //margin: 0 0 16px 0;
        //line-height: 1.4;
    }
    
    &__datetime {
        //font-size: 14px;
        //font-weight: 600;
        //color: $color_dove_gray;
        //margin: 0 0 20px 0;
        //padding: 12px;
        //background-color: $color_wild_sand;
        //border-radius: 8px;
        //border-left: 4px solid #ff9800;
    }
    
    &__instructions {
        //font-size: 14px;
        //color: $color_dove_gray;
        //margin: 0 0 16px 0;
        //line-height: 1.5;
    }
    
    &__apology {
        //font-size: 14px;
        //font-weight: 600;
        //color: $color_blue_cornflower;
        //margin: 0;
        //line-height: 1.4;
    }
}

b {
    font-weight: 600;
}
</style>
